import React, { useState } from "react";
import { Card, CardBody, Col } from 'reactstrap';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentProjectRole } from "../../store/roles";
import { ProjectStatusColor } from "../../constants/StatusColor";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import { withTranslation } from "react-i18next";
import { ProjectStatuses } from "../../constants/Status";
import DescriptionIcon from "@mui/icons-material/Description";
import { getProjectDetails } from "../../api/casp/project";
import { toast } from "react-toastify";
import ShowCommentModal from "../casp/common/ShowCommentModal";

const ProjectDashboardCard = ({ role, project, t }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [openRejectModel, setOpenRejectModel] = useState(false);
    const [rejectReason, setRejectReason] = useState();

    const onProjectClick = () => {
        dispatch(setCurrentProjectRole({ role, project }))
        navigate(`/project/${project.id}/details`, { id: project.id })
    }

    // const getLogoColor = () => {
    //     switch (role) {
    //         case Role.PROJECT_SPONSOR:
    //             return '#34E7ED'; // Set the color for project sponsors
    //         case Role.PROJECT_OWNER:
    //             return '#296CED'; // Set the color for project owners
    //         case Role.PROJECT_MANAGER:
    //             return 'green'; // Set the color for project managers
    //         case Role.MEMBER:
    //             return '#F5D668'; // Set the color for team members
    //         default:
    //             return '#34E7ED'; // Default color
    //     }
    // };

    const handleOpen = async (id) => {
        try {
            const project = (await getProjectDetails(id)).data.data;
            setOpenRejectModel(true);
            setRejectReason({
                name: project.previousApproval?.currentApprovalUser?.user?.name,
                profilePicture: project.previousApproval?.currentApprovalUser?.user?.profilePicture,
                role: project?.previousApproval?.currentApprovalUser?.user?.projectUsers[0]?.role?.name ?? '',
                comment: project?.previousApproval?.comments,
            });
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleRejectModal = () => {
        setOpenRejectModel(!openRejectModel);
        setRejectReason()
    };

    return (
        <Card className="projectCustomCard nw_proj_single_item">
            <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div
                            className="iconbox projectIconBox d-inline-block d-flex align-items-center justify-content-center"
                        >
                            {/* style={{ backgroundColor: getLogoColor() }} */}
                            {/* <i className="las la-file-alt"></i> */}
                            <PostAddOutlinedIcon />
                        </div>
                        <div
                            className="projectDashHeading d-flex justify-content-between"
                            style={{ cursor: "pointer" }} onClick={onProjectClick}>
                            <h5 className=" mb-0 ms-3 text-truncate" style={{ width: '130px', textAlign: 'left' }} title={project.name}>{project.name}</h5>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <h6
                            className={`statusBadge ${ProjectStatusColor(project.status)} justify-content-end mb-0 ms-3 `}
                            style={{ fontSize: "12px" }}
                        >{t(project.status)}
                            {[ProjectStatuses.REJECTED, ProjectStatuses.CONFIRMATION_REJECTED].includes(project.status) && (
                                <DescriptionIcon
                                    style={{ cursor: "pointer", height: '18px' }}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        handleOpen(project?.id)
                                    }}
                                />
                            )}
                        </h6>
                        <i onClick={onProjectClick} className="las la-angle-right cursor-pointer"></i>
                    </div>
                </div>
            </CardBody>

            <div className="rejectModal">
                <ShowCommentModal
                    handleRejectModal={handleRejectModal}
                    open={openRejectModel}
                    data={rejectReason}
                />
            </div>
        </Card>
    );
};
export default withTranslation()(ProjectDashboardCard);